import NftCardMedium from '../../../../components/nftCard/nftCardMedium/NftCardMedium';

interface IMarketVenueCardMainProps {
  id: number;
  address: string;
  cardUrl: string;
  cardAnimationUrl: string;
  category: string | null;
  name: string;
  iconUrl: string;
  availableShares: number;
  totalShares?: number;
}

const MarketVenueCardMain = ({
  id,
  address,
  availableShares,
  cardUrl,
  cardAnimationUrl,
  category,
  name,
  iconUrl,
  totalShares
}: IMarketVenueCardMainProps) => {
  return (
    <NftCardMedium
      backgroundUrl={cardUrl}
      name={name}
      address={address}
      marketUrl={iconUrl}
      backgroundAnimationUrl={cardAnimationUrl}
      category={category}
      id={id}
      shares = {totalShares != null ?
        `${availableShares?.toString()}/${totalShares?.toString()}` :
        availableShares?.toString()
      }
    />
  );
};

export default MarketVenueCardMain;
